<template>
    <div class="orderSubscriptionTab">
        <b-row no-gutters>
            <b-col lg="7" offset-lg="1" order="12">
                <div class="boxItems">
                    <div class="boxItemHeader">
                        <div class="row">
                            <div class="col-6">
                                <h1>Box Items</h1>
                            </div>

                            <div class="col-6">
                                <button 
                                v-if="subscriptions.length > 0"
                                @click="$router.push({name : 'editsubscription'})"
                                class="btn btn-outline-primary">
                                    EDIT
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <box-item :orderboxes="orderboxes"/>
            </b-col>

            <b-col lg="4">
                <template v-for="subs in subscriptions">
                    <div :key="subs.id+'subs'" class="subscriptionList">


                            <div class="subscriptionItem">
                                <h2>
                                    <span class="tlabel">NEXT SHIPMENT SHIPS</span> 
                                    <span 
                                        @click="initeditshippingdate"
                                        class="action">
                                        <b-icon icon="pencil"></b-icon>
                                    </span>
                                </h2>

                                <template v-if="editdeliveryday">
                                    <div class="schecduleDates">

                                        <!-- <template v-for="(day, index) in weekdays">
                                            <div 
                                                @click="selectedday = day.format()"
                                                :key="index"
                                                :class="['schedDateItem', isactivedate(day)]">
                                                <div class="schedDay">
                                                    {{day | formatdate('DD')}}
                                                </div>
                                                <div class="schedDate">
                                                    {{day | formatdate('ddd')}}
                                                </div>
                                            </div>
                                        </template> -->

                                        <div 
                                            :class="['schedDateItem', 'active']">
                                                <div class="schedDay">
                                                    {{getdeliverydate() | notzformatdate('DD')}}
                                                </div>
                                                <div class="schedDate">
                                                    {{getdeliverydate() | notzformatdate('ddd')}}
                                                </div>
                                            </div>
                                    </div>

                                    <div class="editfooteraction">
                                        <button 
                                            @click="editdeliveryday = false"
                                            class="btn btn-outline-primary btn-round">Cancel</button>

                                        <button 
                                            @click="getskippeddates(), $bvModal.show('skipdelivery')"
                                            class="btn btn-outline-primary btn-round">Skip delivery date</button>

                                        <button 
                                            @click="saveshippingdate"
                                            class="btn btn-primary">Save</button>
                                    </div>
                                </template>

                                <template v-else>
                                    <h1>
                                        {{getdeliverydate() | notzformatdate('MMMM D, YYYY')}}
                                    </h1>
                                </template>
                            </div>

                            <div class="subscriptionItem">
                                <h2>SUBSCRIPTION FREQUENCY</h2>
                                <h1>
                                   Every {{getdeliverydate() | notzformatdate('dddd')}}
                                </h1>
                            </div>
                            <div class="subscriptionItem">
                                <h2>
                                    <span class="tlabel">SHIPPING ADDRESS</span> 
                                    <span 
                                        @click="initeditshipping"
                                        class="action">
                                        <b-icon icon="pencil"></b-icon>
                                    </span>
                                </h2>

                                <template v-if="editshipping">
                                    <div class="row">
                                            <div class="col-12">
                                                <input
                                                    id="autocompletesbox"
                                                    v-model="shippingaddress.shipping_address_street"
                                                    type="text"
                                                    placeholder="Street Address"
                                                    class="form-control"
                                                />
                                            </div>

                                            <div class="col-6">
                                                <input
                                                    readonly
                                                    v-model="shippingaddress.shipping_address_city"
                                                    type="text"
                                                    placeholder="City"
                                                    class="form-control"
                                                />
                                            </div>

                                            <div class="col-6">
                                                <input
                                                    readonly
                                                    v-model="shippingaddress.shipping_address_state"
                                                    type="text"
                                                    placeholder="State"
                                                    class="form-control"
                                                />
                                            </div>

                                            <div class="col-6">
                                                <input
                                                    readonly
                                                    v-model="shippingaddress.shipping_address_zipcode"
                                                    type="text"
                                                    placeholder="Zip"
                                                    class="form-control"
                                                />
                                            </div>

                                            <b-col cols="12">
                                                <div class="editfooteraction">
                                                    <button 
                                                        @click="editshipping = false"
                                                        class="btn btn-outline-primary btn-round">Cancel</button>
                                                    <button 
                                                        @click="updateshippingaddress"
                                                        class="btn btn-primary">Save</button>
                                                </div>
                                            </b-col>
                                        </div>
                                </template>

                                <template v-else>
                                    <h1>
                                        {{subs.order.shipping_address_street}} {{subs.order.shipping_address_city}} {{subs.order.shipping_address_state}} {{subs.order.shipping_address_zipcode}}
                                    </h1>
                                </template>
                              
                            </div>

                    </div>
                </template>
            </b-col>
        </b-row>

        <b-modal id="editshippingdate" hide-footer hide-header>
            <div class="d-block text-center mt-5">
                <h3><b-icon icon="truck"></b-icon></h3>
                <h3>Change Delivery Date</h3>

                <p>Date changes will take effect on next order process.</p>
            </div>

            <button
                class="btn btn-outline-primary btn-round block mt-5" 
                @click="$bvModal.hide('editshippingdate')">
                Cancel
            </button>
            <b-button 
                class="mt-4 mb-5" 
                variant="primary"  
                block 
                @click="changeshippingdate">Continue</b-button>
        </b-modal>

         <b-modal id="unsubscribe" hide-footer hide-header>
            <div class="d-block text-center mt-5">
                <h3><b-icon icon="truck"></b-icon></h3>
                <h3>Unsubscribe</h3>

                <p>Unsubscribing will cancel future deliveries.</p>
                <p><b>Note : All deliveries for today will still be processed.</b></p>
            </div>

            <button
                class="btn btn-outline-primary btn-round block mt-5" 
                @click="$bvModal.hide('unsubscribe')">
                Cancel
            </button>
            <b-button 
                class="mt-4 mb-5" 
                variant="primary"  
                block 
                @click="unsubscribe">Continue</b-button>
        </b-modal>
        
        <b-modal id="skipdelivery" hide-footer hide-header>
            <div class="d-block text-center mt-5">
                <h3><b-icon icon="truck"></b-icon></h3>
                <h3>Skip delivery</h3>

                <p>Next 5 deliveries</p>

                <div class="deliveries">
                    <template v-for="(delivery, index) in nextdeliveries">
                        <div :key="index" class="deliverydate">
                             <b-form-checkbox
                                v-model="selectedskipdeliveries"
                                name="checkbox-1"
                                :value="delivery"
                                unchecked-value=""
                                >
                                {{delivery | notzformatdate('MM/DD/YYYY')}}
                            </b-form-checkbox>
                        </div>
                    </template>
                </div>
            </div>

            <button
                class="btn btn-outline-primary btn-round block mt-5" 
                @click="$bvModal.hide('skipdelivery')">
                Cancel
            </button>
            <button
                class="btn btn-outline-primary btn-round block mt-4" 
                @click="$bvModal.hide('skipdelivery'), $bvModal.show('unsubscribe')">
                Unsubscribe
            </button>
            <b-button 
                class="mt-4 mb-5" 
                variant="primary"  
                block 
                @click="skippingdates = true, $bvModal.hide('skipdelivery')">Continue</b-button>
        </b-modal>
    </div>
</template>

<script>
// components
import boxItem from "@/components/boxItem.vue";

// Plugins
import moment from 'moment'
import axios from 'axios';

// Helpers
import {newJob} from '@/helpers/localbase'
import Helper from '@/helpers/helper'

// Mixins
import {gmapmixins} from '@/mixins/gmapmixins'
import {ordermixins} from '@/mixins/ordermixins'

export default {
    mixins : [gmapmixins, ordermixins],
    components: {
        "box-item": boxItem,
    },
    data() {
        return {
            selectedskipdeliveries: [],
            nextdeliveries        : [],
            selectedday           : moment().endOf('day'),
            editshipping          : false,
            editdeliveryday       : false,
            skippingdates         : false,
            shippingaddress       : {
                shipping_address_street   : "",
                shipping_address_city     : "",
                shipping_address_state    : "UT",
                shipping_address_zipcode  : "",
                shipping_address_latitude : "",
                shipping_address_longitude: "",
            }
        }
    },
    computed : {
        /**
         * Network status
         */
        isonline() {
            return this.$store.state.isonline
        },
        /**
         * User subscription
         */
        subscriptions : {
            get() {
                return this.$store.state.subscriptions;
            },
            set(list) {
                this.$store.commit('updateSubscriptions', list);
            }
        }
    },
    filters : {
        /**
         * Format date by 
         * @param format @example "MM-DD-YYYY"
         */
        formatdate(date, format) {
            return date ? Helper.formatdate(date, format) : '';
        },
        /**
         * Format date by 
         * @param format @example "MM-DD-YYYY"
         */
        notzformatdate(date, format) {
            return date ? moment(date).utc().format(format) : '';
        },
    },
    methods : {
        /**
         * Check subscription delivery dates if over the today's date
         * then return next delivery date
         */
        getdeliverydate() {
            const [sub] = this.subscriptions
            if(sub) {
                if(moment(sub.delivery_date).isSameOrAfter(moment(), 'day')) {
                    return sub.delivery_date
                } else {
                    return sub.next_shipment_at
                }
            } else {
                return ''
            }
        },

        /**
         * Update shipping address
         */
        async updateshippingaddress() {
            const url = `/update_shipping_address`;

            const res = await axios.post(url, this.shippingaddress);

            if(res.data.success) {
                this.$store.dispatch('getSubscriptions')
                this.editshipping = false;
            } else if(!this.isonline) {
                /**
                 * If offline add request to job
                 * 
                 */
                newJob({
                    url   : url,
                    method: "POST",
                    params: this.shippingaddress,
                    callback : (data, options) => {
                        if(data.success) {
                            options.store.store.dispatch('getSubscriptions');
                        }
                    }
                })
            }
        },
        /**
         * Unsubscribe 
         */
        async unsubscribe() {
            this.editdeliveryday = false;
            this.$bvModal.hide('unsubscribe');

            const [sub] = this.subscriptions;

            if(sub) {
                const url   = `/subscriptions/${sub.id}`
                const res   = await axios.delete(url).catch(err => console.log(err))

                if(res.data.success) {
                    this.$store.dispatch('getSubscriptions');
                    this.$store.dispatch('getsubboxitems', sub.id);
                } else if(!this.isonline) {
                    /**
                     * if online add request to jo
                     */
                    newJob({
                        url   : url,
                        method: 'DELETE'
                    })
                }
            }

        },
        /**
         * Save changes for shipping / delivery dates
         * if user skip delivery the change ignore change from change delivery date
         */
         saveshippingdate() {
            this.editshipping = false;
            this.$bvModal.show('editshippingdate');
        },
        /**
         * Skip Deliveries
         */
        async skipdeliveries() {
                  this.skippingdates = false
            const [sub]              = this.subscriptions
            const url                = `update_skip_deliveries/${sub.id}`

            const dates = this.selectedskipdeliveries.map(date => moment(date).format('YYYY-MM-DD'))
            const params = {dates : dates}
            const res = await axios.post(url, params).catch(err => console.log(err))
            
            if(res.data.success) {
                this.$store.dispatch('getSubscriptions')
            } else if(!this.isonline) {
                /**
                 * If offline add request to job
                 */
                newJob({
                    url     : url,
                    method  : "POST",
                    params  : params,
                    callback: (data, options) => {
                        /**
                         * Check if success and call get subscription 
                         */
                        if(data.success) {
                            options.store.dispatch('getSubscriptions')
                        }
                    }
                })
            }
        },
        /**
         * changing shipping date
         * don't proceed if skipping dates are present
         */
        async changeshippingdate() {

            this.$bvModal.hide('editshippingdate')
                //   this.editdeliveryday = false
            // const [sub]                = this.subscriptions

            /**
             * Check if skipping and ignore changes to delivery date
             * also check if the change is now same date
             */ 
            if(!this.skippingdates) {
                // const nextdate    = moment(this.selectedday)
                // const currentdate = moment(sub.next_shipment_at)
                // const params      = {next_shipping_date : nextdate.format('YYYY-MM-DD')}

                // if(!nextdate.isSame(currentdate, 'day')) {
                //     const url = `/update_next_shipping_date/${sub.id}`
                //     const res = await axios.post(url, params).catch(err => console.log(err))
                //     if(res.data.success) {
                //         this.$store.dispatch('getSubscriptions')
                //     } else if(!this.isonline) {
                //         /**
                //          * If offline add request to job
                //          */
                //         newJob({
                //             url : url,
                //             method : "POST",
                //             params : params,
                //             callback : (data, options) => {
                //                 /**
                //                  * Check if success and call get subscription 
                //                  */
                //                 if(data.success) {
                //                     options.store.dispatch('getSubscriptions')
                //                 }
                //             }
                //         })
                //     }
                // }
            } else {
                /**
                 * Process skip deliveries 
                 */
                this.skipdeliveries()
            }

            this.editdeliveryday = false;
        },
        /**
         * Get next 5 delivery dates 
         * for skipping subscription delivery dates
         * User cannot skip delivery if the dates is today
         * 
         */
        getdeliverydates() {
            // const [sub]          = this.subscriptions
            const format         = 'YYYY-MM-DD'
            let   deliverydate   = moment(this.getdeliverydate())
            let   nextdeliveries = []

            /**
             * Check if deliverydate is within processing period which is today and tomorrow 
             * do not include first delivery date to the skip date list
             */

            if(!deliverydate.isSame(moment(), 'day' || !deliverydate.isSame(moment().subtract(1, 'day'), 'day'))) {
                nextdeliveries = [deliverydate.utc().format(format)]
            }

            while (nextdeliveries.length < 5) {

                deliverydate = deliverydate.utc().add(7, 'days');

                console.log(deliverydate.day(), 'deliverydate', deliverydate)

                if(deliverydate.day() != 6 && deliverydate.day() != 0 ) {
                    nextdeliveries = [...nextdeliveries, deliverydate.format(format)];
                }

            }

            this.nextdeliveries = nextdeliveries;

        },
        /**
         * Set local state for delivery/shipping date
         * and set edit delivery/shpping date state
         */
        initeditshippingdate() {
            const [sub]                = this.subscriptions;
                  this.selectedday     = sub ? moment(sub.next_shipment_at) : moment();
                  this.editdeliveryday = true;

                // Get next delivery dates
                // this.getdeliverydates();

                
                /**
                 * Get skipped dates
                 */
                // this.getskippeddates();
        },
        /**
         * Check if selected day is same with date from the loop
         */
        isactivedate(date) {
            return moment(date).isSame(this.selectedday, 'day') ? 'active' : '';
        },
        /**
         * Edit Shipping
         * initialize autocomplete address
         */ 
        initeditshipping() {
                  this.editshipping = true;
            const [sub]             = this.subscriptions;

            this.shippingaddress = {
                shipping_address_street   : sub.order.shipping_address_street,
                shipping_address_city     : sub.order.shipping_address_city,
                shipping_address_state    : sub.order.shipping_address_state,
                shipping_address_zipcode  : sub.order.shipping_address_zipcode,
                shipping_address_latitude : sub.order.shipping_address_latitude,
                shipping_address_longitude: sub.order.shipping_address_longitude,
            }

            setTimeout(() => {
                this.autocompleteaddress();
            }, 200);
        },
         /**
         * autocomplete place will query from google map api to get address suggestion.
         * @param {DOM} inputbox input box where the autocomplete will trigger
         */
        autocompleteaddress() {
            const inputbox = document.getElementById('autocompletesbox');

            if(inputbox) {
                /**
                 * Callback
                 * Process return data from autocomplete address
                 */
                const callback = (data) => {
                   this.$nextTick(() => {
                        /**
                         * get latitude and longtitude
                         */
                        this.shippingaddress.shipping_address_latitude  = data.geometry.location.lat();
                        this.shippingaddress.shipping_address_longitude = data.geometry.location.lng();

                        /**
                         * get street, city, state, zipcode
                         */
                        // get street
                        const streetnumber = data.address_components.find(d => d.types.includes('street_number'));
                        const street       = data.address_components.find(d => d.types.includes('street'));
                        const route        = data.address_components.find(d => d.types.includes('route'));
                        
                        this.shippingaddress.shipping_address_street = `${streetnumber ? streetnumber.short_name : ''} ${street ? street.short_name : ''} ${route ? route.long_name : ''}`;
                        
                        // get city
                        const city                                       = data.address_components.find(d => d.types.includes('locality') || d.types.includes('postal_town'));
                              this.shippingaddress.shipping_address_city = city.long_name;

                         // get state
                        const state                                       = data.address_components.find(d => d.types.includes('administrative_area_level_1'));
                              this.shippingaddress.shipping_address_state = state.short_name;


                        // get postal_code
                        const postalcode                                    = data.address_components.find(d => d.types.includes('postal_code') || d.types.includes('postal_code_suffix'));
                              this.shippingaddress.shipping_address_zipcode = postalcode.short_name;
                   });

                }

                this.autocompletedress(inputbox, callback);
            }
        },
        /**
         * Get subscription order details
         */
        getorder() { 
            const [subscription] = this.$store.state.subscriptions;
            console.log('subscription', subscription)
            if(subscription) {
                const url = `/subscriptions/${subscription.id}`;
                axios.get(url).then(res => {
                    if(res.data.success) {
                        this.$store.commit('updateorderboxes', res.data.data);
                    }
                }).catch(() => {
                    /**
                     * If failed due to network issue
                     * add api job for recalling once network status came online
                     */
                    if(!this.isonline) {
                        newJob({
                            url   : url,
                            method: 'GET',
                            callback(data, options) {
                                if(data.success) {
                                    options.store.commit('updateorderboxes', data.data)
                                }
                            }
                        })
                    }
                })
            }
        },
        /**
         * Get skipped dates
         */
        getskippeddates() {
            const [sub]  = this.subscriptions

            this.getdeliverydates();

            if(sub) {
                // this.selectedskipdeliveries = sub.delivery_skip_dates.map(skipped => moment(skipped.skip_date).utc().format('YYYY-MM-DD'))
                // this.selectedskipdeliveries = sub.delivery_skip_dates.map(skipped => Helper.formatdate(skipped.skip_date, 'YYYY-MM-DD'))
                this.selectedskipdeliveries = sub.delivery_skip_dates.map(skipped => {
                    const date = skipped.skip_date.substring(0, skipped.skip_date.indexOf('T'))

                    return date
                })

            }
        }
    },
    created() {
         /**
         * Reset item boxes
         */
        this.$store.commit('updateorderboxes', [])
    },
    /**
     * Run function before component render
     */
    async beforeMount() {
        // Get user subscriptoin
        await this.$store.dispatch('getSubscriptions');

       

        // get subscription item
        const [sub] = this.subscriptions;
        if(sub) {
            this.$store.dispatch('getsubboxitems', sub.id);
        } 
         // Get order boxes
         // disable for now not in-use
        // this.getorder();


        // initiate address autocomplete
        // Initiate google map 
        this.$gmapApiPromiseLazy().then(() => {
            this.initMap();
        });

        // Get dates for the week
        this.getweekdays();

     
    }
};
</script>

<style lang="scss">
@import '@/scss/_settings.scss';

#skipdelivery {
    label {
        font-size : 20px;

        &::after, &::before {
            top : 8px;
        }
    }

    .btn {
        width : 300px;
    }
}

.orderSubscriptionTab {

    .schecduleDates {
        .schedDateItem {
            background-color: darken($color: $medium-gray, $amount: 10);

            
            &.active {
                color           : white;
                background-color: $primary-color;
            }
        }
        
    }

    .boxItemHeader {
        .btn {
            border-radius: 30px;
            padding-left : 30px;
            padding-right: 30px;
            font-weight  : 500;
        }
    }
    
    h2 {
        display: flex;
        
        .action {
            color      : $primary-color;
            margin-left: 15px;
            cursor     : pointer;
        }
    }

    .form-control {
        border-color    : transparent;
        padding-left    : 0;
        background-color: transparent;
        font-size       : 25px;
        font-weight     : 300;

        &:focus {
            outline   : none;
            box-shadow: none;
        }
    }

    .editfooteraction {
        .btn {
            margin-right : 15px;
            margin-top : 15px;
        }
    }
}
</style>
